<template>
  <v-card>
    <v-container fluid>
      <v-row class="mt-2 mb-4 mx-2">
        <v-col>
          <v-row>
            <v-col cols="12" sm="11">
              <v-row align="center">
                <h2 class="text-h6 text-sm-h4" style="color: #ca0538">
                  {{ substanceItem.usual_name }}
                </h2>
              </v-row>
              <v-row class="pt-2">
                <v-col>
                  <v-row align="baseline">
                    <h3 class="text-h6">N° CE :</h3>

                    <p class="text-body-1 mb-0 ml-3">
                      {{ substanceItem.ce }}
                    </p>
                  </v-row>
                  <v-row align="baseline">
                    <h3 class="text-h6">N° CAS :</h3>

                    <p class="text-body-1 mb-0 ml-3">
                      {{ substanceItem.cas }}
                    </p>
                  </v-row>
                  <v-row>
                    <v-col class="pl-0">
                      <h3 class="text-h6">
                        {{ $t("showSubstance.synonym") }} :
                      </h3>
                      <ul v-if="arrayLength(substanceItem.synonymes)">
                        <li
                          v-for="(synonyme, i) in substanceItem.synonymes"
                          :key="i"
                        >
                          <v-icon x-small color="primary">
                            mdi-beaker-outline
                          </v-icon>
                          {{ synonyme }}
                        </li>
                      </ul>
                      <p v-else>{{ $t("showSubstance.noSynonym") }}</p>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col>
                  <h3 class="text-h6">{{ $t("showSubstance.uses") }} :</h3>
                  <div class="manyuses overflow-y-auto">
                    <ul v-if="arrayLength(substanceItem.usescase)">
                      <li v-for="(use, i) in substanceItem.usescase" :key="i">
                        <v-icon x-small color="primary"> mdi-palette </v-icon>
                        {{ use }}
                      </li>
                    </ul>
                    <p v-else>{{ $t("showSubstance.noUse") }}</p>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="1" align="end">
              <v-row justify="end">
                <v-btn
                  class="mb-3"
                  x-large
                  color="primary"
                  icon
                  @click="toggle_fav"
                >
                  <v-icon x-large v-if="love"> mdi-heart </v-icon>
                  <v-icon x-large v-else> mdi-heart-outline </v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<style scoped>
ul {
  list-style: none;
}
.manyuses {
  height: 150px;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { monitore } from "./helpers/helpers";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["subs_fav", "identity"]), //array of id
    love() {
      let a = false;
      if (this.subs_fav.indexOf(this.substanceItem._id) < 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  props: {
    substanceItem: Object,
  },
  components: {},
  methods: {
    ...mapMutations(["addSubFav", "deleteSubFav"]),
    ...mapActions(["updateProfile"]),
    async toggle_fav() {
      if (this.love) {
        let index = this.subs_fav.indexOf(this.substanceItem._id);
        this.deleteSubFav({ id: this.substanceItem._id, index: index });
        await this.updateProfile();
      } else {
        // is not fav -> add
        this.addSubFav(this.substanceItem._id);
        monitore("Add sub fav", this.substanceItem._id);
        await this.updateProfile();
      }
    },
    arrayLength(array) {
      let arr = array || [];
      return arr.length;
    },
  },
};
</script>